export { default } from './HocProfileManager';
